import SectionHeading from '@/pages/home/components/SectionHeading';
import { entryChannels } from '@/mocks/home';

export default function EntryOverview() {
  return (
    <section id="entry" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="入口总览"
          title="四类官方入口，按需要选择"
          desc="不同使用场景对应不同入口。先在下面对照自己的情况选定一种，再按后文的访问指南操作，可以减少在多个页面间反复尝试的情况。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {entryChannels.map((c, idx) => (
            <article
              key={c.name}
              className={`rounded-lg p-6 md:p-7 border transition-colors ${
                idx === 0
                  ? 'bg-primary-50 border-primary-200'
                  : idx === 3
                    ? 'bg-accent-50 border-accent-200'
                    : 'bg-background-100 border-background-200/70'
              }`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-50 text-primary-700 border border-background-200/70">
                  <i className={`${c.icon} text-2xl`}></i>
                </div>
                <span
                  className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-100 text-primary-800'
                      : idx === 3
                        ? 'bg-accent-100 text-accent-800'
                        : 'bg-secondary-100 text-secondary-900'
                  }`}
                >
                  {c.tag}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg md:text-xl font-semibold text-foreground-950">{c.name}</h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-500">{c.summary}</p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{c.desc}</p>

              <ul className="mt-4 flex flex-wrap gap-2">
                {c.points.map((p) => (
                  <li key={p} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-background-50 border border-background-200/70 text-xs text-foreground-700">
                    <i className="ri-check-line text-primary-600"></i>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}